export const ERROR_MESSAGES = {
  CHARGIFY: {
    PAYMENT_TOKEN_FAILED: 'ERROR.CHARGIFY.PAYMENT_TOKEN_FAILED',
    PAYMENT_FORM_NOT_FOUND: 'ERROR.CHARGIFY.PAYMENT_FORM_NOT_FOUND',
    PAYMENT_FORM_ELEMENT_NOT_FOUND:
      'ERROR.CHARGIFY.PAYMENT_FORM_ELEMENT_NOT_FOUND',
    CHARGIFY_CONFIG_NOT_FOUND: 'ERROR.CHARGIFY.CHARGIFY_CONFIG_NOT_FOUND',
    CHARGIFY_NOT_LOADED: 'ERROR.CHARGIFY.CHARGIFY_NOT_LOADED',
    CHARGIFY_NOT_INITIALIZED: 'ERROR.CHARGIFY.CHARGIFY_NOT_INITIALIZED',
    CHARGIFY_TOKEN_MISSING: 'ERROR.CHARGIFY.CHARGIFY_TOKEN_MISSING',
  },
  PURCHASE: {
    PURCHASE_ERROR: 'PURCHASE.MESSAGES.PURCHASE_ERROR',
    FORM_INVALID: 'PURCHASE.MESSAGES.FORM_INVALID',
  },
  GENERAL: {
    GENERAL_ERROR: 'ERROR.GENERAL_ERROR',
  },
} as const;
